var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "base-card",
            [
              _c("v-card-title", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.editing
                        ? "Editar Configuración Puntos Colombia"
                        : "Configuración Puntos Colombia"
                    ) +
                    " "
                ),
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    { ref: "form" },
                    [
                      _c(
                        "v-row",
                        [
                          _vm.hasElevatedRole
                            ? _c(
                                "v-col",
                                { attrs: { cols: "12", md: "4" } },
                                [
                                  _c("v-select", {
                                    ref: "cliente",
                                    attrs: {
                                      items: _vm.filteredClients,
                                      "item-text": "text",
                                      "item-value": "IdCompania",
                                      label: "Compañía",
                                      "prepend-inner-icon": "mdi-sitemap",
                                      disabled: _vm.editing,
                                      rules: [_vm.requiredRule],
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "prepend-item",
                                          fn: function () {
                                            return [
                                              _c(
                                                "v-list-item",
                                                [
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          "hide-details": "",
                                                          placeholder: "Buscar",
                                                          "prepend-inner-icon":
                                                            "mdi-magnify",
                                                        },
                                                        model: {
                                                          value: _vm.search,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.search = $$v
                                                          },
                                                          expression: "search",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      3897567296
                                    ),
                                    model: {
                                      value: _vm.form.IdCompania,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "IdCompania", $$v)
                                      },
                                      expression: "form.IdCompania",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "2" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: ["UAT", "PRD"],
                                  label: "Ambiente",
                                  rules: [_vm.requiredRule],
                                },
                                model: {
                                  value: _vm.form.Environment,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "Environment", $$v)
                                  },
                                  expression: "form.Environment",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "2" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Partner Code",
                                  rules: [_vm.requiredRule],
                                },
                                model: {
                                  value: _vm.form.PartnerCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "PartnerCode", $$v)
                                  },
                                  expression: "form.PartnerCode",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "2" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.channelItems,
                                  "item-text": "text",
                                  "item-value": "value",
                                  label: "Canal",
                                  rules: [_vm.requiredRule],
                                },
                                model: {
                                  value: _vm.form.Channel,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "Channel", $$v)
                                  },
                                  expression: "form.Channel",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Client Id",
                                  rules: [_vm.requiredRule],
                                },
                                model: {
                                  value: _vm.form.ClientId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "ClientId", $$v)
                                  },
                                  expression: "form.ClientId",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Client Secret",
                                  rules: [_vm.requiredRule],
                                  "append-icon": _vm.showClientSecret
                                    ? "mdi-eye-off"
                                    : "mdi-eye",
                                  type: _vm.showClientSecret
                                    ? "text"
                                    : "password",
                                },
                                on: {
                                  "click:append": function ($event) {
                                    _vm.showClientSecret = !_vm.showClientSecret
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "append-outer",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              icon: "",
                                                              small: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.copyText(
                                                                  _vm.form
                                                                    .ClientSecret
                                                                )
                                                              },
                                                            },
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " mdi-content-copy "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ]),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v("Copiar Client Secret"),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value: _vm.form.ClientSecret,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "ClientSecret", $$v)
                                  },
                                  expression: "form.ClientSecret",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _c("v-file-input", {
                                attrs: {
                                  accept: ".p12",
                                  label: "Certificado P12",
                                  "prepend-icon": "mdi-file-certificate",
                                  rules: _vm.editing ? [] : [_vm.requiredRule],
                                },
                                model: {
                                  value: _vm.certificate,
                                  callback: function ($$v) {
                                    _vm.certificate = $$v
                                  },
                                  expression: "certificate",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Password Certificado",
                                  rules: [_vm.requiredRule],
                                  "append-icon": _vm.showPassword
                                    ? "mdi-eye-off"
                                    : "mdi-eye",
                                  type: _vm.showPassword ? "text" : "password",
                                },
                                on: {
                                  "click:append": function ($event) {
                                    _vm.showPassword = !_vm.showPassword
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "append-outer",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              icon: "",
                                                              small: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.copyText(
                                                                  _vm.form
                                                                    .CertificatePassword
                                                                )
                                                              },
                                                            },
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " mdi-content-copy "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ]),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v("Copiar contraseña"),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value: _vm.form.CertificatePassword,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "CertificatePassword",
                                      $$v
                                    )
                                  },
                                  expression: "form.CertificatePassword",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _vm.editing
                            ? _c("v-col", { attrs: { cols: "12", md: "6" } })
                            : _vm._e(),
                          !_vm.editing
                            ? _c("v-col", { attrs: { cols: "12", md: "8" } })
                            : _vm._e(),
                          _vm.editing
                            ? _c(
                                "v-col",
                                { attrs: { cols: "12", md: "2" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        block: "",
                                        outlined: "",
                                        color: "grey",
                                      },
                                      on: { click: _vm.cancelEdit },
                                    },
                                    [_vm._v(" CANCELAR ")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "2" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticStyle: {
                                    "background-color": "rgb(204 33 40)",
                                    color: "white !important",
                                  },
                                  attrs: { block: "", dark: "" },
                                  on: { click: _vm.save },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.editing ? "ACTUALIZAR" : "GUARDAR"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-alert",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.successAlert,
                              expression: "successAlert",
                            },
                          ],
                          staticClass: "mb-4",
                          attrs: { type: "success", text: "" },
                        },
                        [_vm._v(" " + _vm._s(_vm.msgSuccessAlert) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }